import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import UploadingOverlay from 'components/uploading_overlay/uploading_overlay'

class IVideoUploadingOverlay extends PureComponent {

	render() {
		return (
			<UploadingOverlay
				message={this.props.message}
				buttonLabel={this.props.buttonLabel}
				buttonHandler={this.props.buttonHandler}
			/>
		)
	}
}

IVideoUploadingOverlay.propTypes = {
	message: PropTypes.array,
	buttonLabel: PropTypes.string,
	buttonHandler: PropTypes.func,
}

export default IVideoUploadingOverlay
